// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Cancellation24Hours20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Cancellation24Hours20Circle: FC<Cancellation24Hours20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="25"
        >
            <path
                d="M12 .5c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12S5.373.5 12 .5Zm0 4a7.79 7.79 0 0 0-3.108.625 8.076 8.076 0 0 0-4.267 4.26A7.75 7.75 0 0 0 4 12.49c0 1.105.208 2.144.625 3.115.417.972.99 1.822 1.719 2.551a8.075 8.075 0 0 0 2.548 1.719c.97.417 2.006.625 3.108.625V19c-1.806 0-3.34-.632-4.604-1.895C6.132 15.84 5.5 14.305 5.5 12.5c0-1.806.632-3.34 1.896-4.604C8.659 6.632 10.194 6 12 6V4.5Zm2.498 13.75a.96.96 0 0 0-.709.292.97.97 0 0 0-.289.71c0 .28.098.516.292.709a.97.97 0 0 0 .71.289.96.96 0 0 0 .709-.292.97.97 0 0 0 .289-.71.96.96 0 0 0-.292-.709.97.97 0 0 0-.71-.289Zm3.5-3a.96.96 0 0 0-.709.292.97.97 0 0 0-.289.71c0 .28.098.516.292.709a.97.97 0 0 0 .71.289.96.96 0 0 0 .709-.292.97.97 0 0 0 .289-.71.96.96 0 0 0-.292-.709.97.97 0 0 0-.71-.289ZM11.25 7.5v5l3.542 3.542 1.063-1.063-3.105-3.104V7.5h-1.5Zm7.748 4a.96.96 0 0 0-.709.292.97.97 0 0 0-.289.71c0 .28.098.516.292.709a.97.97 0 0 0 .71.289.96.96 0 0 0 .709-.292.97.97 0 0 0 .289-.71.96.96 0 0 0-.292-.709.97.97 0 0 0-.71-.289Zm-1-3.75a.96.96 0 0 0-.709.292.97.97 0 0 0-.289.71c0 .28.098.516.292.709a.97.97 0 0 0 .71.289.96.96 0 0 0 .709-.292.97.97 0 0 0 .289-.71.96.96 0 0 0-.292-.709.97.97 0 0 0-.71-.289Zm-3.5-3a.96.96 0 0 0-.709.292.97.97 0 0 0-.289.71c0 .28.098.516.292.709a.97.97 0 0 0 .71.289.96.96 0 0 0 .709-.292.97.97 0 0 0 .289-.71.96.96 0 0 0-.292-.709.97.97 0 0 0-.71-.289Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Cancellation24Hours20Circle;
